/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { badResponseModelSchema } from "../badResponseModelSchema.ts";
import { tagContentTypeEnumSchema } from "../tagContentTypeEnumSchema.ts";
import { tagModelPagedResultSchema } from "../tagModelPagedResultSchema.ts";
import { z } from "zod";

export const getApiTagsQueryParamsSchema = z.object({
    "Types": z.array(z.lazy(() => tagContentTypeEnumSchema).describe("Типы контента, на который распространяются жанры<p>Возможные значения:</p>\n<ul>\n<li><b>1 - Music</b>: Музыка</li>\n<li><b>2 - Podcast</b>: Подкаст</li>\n<li><b>3 - Book</b>: Книга</li>\n<li><b>4 - Album</b>: Альбом</li>\n<li><b>5 - Mood</b>: Настроение</li>\n</ul>\n")).describe("Фильтр по типу").optional(),
"TagIds": z.array(z.coerce.number().int()).describe("Фильтр по идентификаторам").optional(),
"SearchQuery": z.string().describe("Строка поиска").optional(),
"Limit": z.coerce.number().int().describe("Пагинация - сколько необходимо получить элементов").optional(),
"Offset": z.coerce.number().int().describe("Пагинация - сколько необходимо пропустить элементов").optional()
    }).optional()

/**
 * @description Список жанров
 */
export const getApiTags200Schema = z.lazy(() => tagModelPagedResultSchema)

/**
 * @description Ошибка в параметрах запроса | Ошибка валидации
 */
export const getApiTags400Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Пользователь не авторизован
 */
export const getApiTags401Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Недостаточно прав для выполнения запроса
 */
export const getApiTags403Schema = z.lazy(() => badResponseModelSchema)

/**
 * @description Внутренняя ошибка сервера
 */
export const getApiTags500Schema = z.lazy(() => badResponseModelSchema)

export const getApiTagsQueryResponseSchema = z.lazy(() => getApiTags200Schema)